var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCarsAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 179,
    viewBox: "0 0 202 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qxez81tpva",
    d: "M0 0h18.92v18.871H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.448 53.96s-9.1-1.598-10.941-1.598c-1.598 0-1.224 13.015-10.871 15.113-.64-.024-1.332.01-2.084.115-.54.076-1.052.119-1.552.146a18.34 18.34 0 0 1-1.552-.146 11.729 11.729 0 0 0-2.083-.115c-9.647-2.098-9.274-15.113-10.871-15.113-1.843 0-10.942 1.598-10.942 1.598s-.641 35.556-.641 39.886c0 2.626 17.522 1.154 26.09.342 8.565.812 26.088 4.385 26.088-.342 0-4.33-.64-39.886-.64-39.886",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.001 51.933-1.026-12.022H95.706l-1.02 11.943c-7.944.409-13.195 1.604-13.195 1.604v47.086h40.015V53.458s-6.424-1.061-14.505-1.525",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.001 51.933-1.026-12.022H95.706l-1.02 11.943c-7.944.409-13.195 1.604-13.195 1.604v47.086h40.015V53.458s-6.424-1.061-14.505-1.525z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.143 171.173c-2.37 1.05-36.855 6.827-36.855 6.827s-.79-3.676 2.632-4.99c3.423-1.311 1.317-6.563 7.371-7.876 6.055-1.313 13.69-4.463 14.742-7.352 1.053-2.887 2.106-4.988 4.476-4.988 2.369 0 8.16 3.15 8.16 3.15l-.526 15.23z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.143 171.173c-2.37 1.05-36.855 6.827-36.855 6.827s-.79-3.676 2.632-4.99c3.423-1.311 1.317-6.563 7.371-7.876 6.055-1.313 13.69-4.463 14.742-7.352 1.053-2.887 2.106-4.988 4.476-4.988 2.369 0 8.16 3.15 8.16 3.15l-.526 15.23z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.315 174.811 123.464-19.166c8.352-1.297 14.64-8.268 15.051-16.687.413-8.42-5.164-15.97-13.35-18.071l-64.918-16.672-.333-5.509H90.376l.297 34.008 4.214 1.083-38.051 5.907 5.479 35.107z",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6176F4",
    d: "m62.315 174.811 123.464-19.166-5.479-35.108-123.464 19.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.934 171.173c2.369 1.05 36.855 6.827 36.855 6.827s.79-3.676-2.632-4.99c-3.423-1.311-1.317-6.563-7.372-7.876-6.055-1.313-13.689-4.463-14.742-7.352-1.053-2.887-2.106-4.988-4.475-4.988-2.37 0-8.161 3.15-8.161 3.15l.527 15.23z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.934 171.173c2.369 1.05 36.855 6.827 36.855 6.827s.79-3.676-2.632-4.99c-3.423-1.311-1.317-6.563-7.372-7.876-6.055-1.313-13.689-4.463-14.742-7.352-1.053-2.887-2.106-4.988-4.475-4.988-2.37 0-8.161 3.15-8.161 3.15l.527 15.23z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.925 23.089c0 7.975-6.483 14.44-14.48 14.44-7.996 0-14.478-6.465-14.478-14.44 0-7.976 6.482-14.441 14.479-14.441 7.996 0 14.479 6.465 14.479 14.44",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qyo8rqsf6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qxez81tpva"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 9.436c0 5.21-4.235 9.435-9.46 9.435-5.225 0-9.46-4.225-9.46-9.435C0 4.225 4.235 0 9.46 0c5.225 0 9.46 4.225 9.46 9.436",
    fill: "#000",
    mask: "url(#qyo8rqsf6b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.892,
    d: "M164.613 124.7 56.836 139.704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.53 43.052s3.403-1.386 3.872-3.996c.47-2.61-.115-4.27.964-6.026 1.079-1.754 2.695-2.68 2.916-2.606.22.074.928.88.437 2.1-.492 1.218-.302 5.026.087 6.783.186.842 9.27 12.988 8.88 15.339-1.432 8.636-16.692-10.544-17.156-11.594",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.53 43.052s3.403-1.386 3.872-3.996c.47-2.61-.115-4.27.964-6.026 1.079-1.754 2.695-2.68 2.916-2.606.22.074.928.88.437 2.1-.492 1.218-.302 5.026.087 6.783.186.842 9.27 12.988 8.88 15.339-1.432 8.636-16.692-10.544-17.156-11.594z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.995 30.98s4.627-.6 5.83-.467c1.204.132 8.45 1.037 8.45 1.037s1.111 1.269-.68 2.042c-1.792.775-7.829.282-8.56.27-.73-.01-6.421 2.66-6.276 2.294.145-.366 1.236-5.176 1.236-5.176",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.995 30.98s4.627-.6 5.83-.467c1.204.132 8.45 1.037 8.45 1.037s1.111 1.269-.68 2.042c-1.792.775-7.829.282-8.56.27-.73-.01-6.421 2.66-6.276 2.294.145-.366 1.236-5.176 1.236-5.176z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.665 28.93s8.119-1.013 8.892-1.067c.771-.054 2.926-.961 3.037-.706.11.255.31 2.221-1.16 2.927-1.472.705-9.28 2.378-10.985 1.738-1.704-.64.216-2.892.216-2.892",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.665 28.93s8.119-1.013 8.892-1.067c.771-.054 2.926-.961 3.037-.706.11.255.31 2.221-1.16 2.927-1.472.705-9.28 2.378-10.985 1.738-1.704-.64.216-2.892.216-2.892z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.635 38.276s-.235-2.907.34-4.65c.578-1.74 5.694-11.766 5.694-11.766s1.635.32.455 3.418c-1.179 3.1-4.19 11.725-1.078 16.303 3.113 4.58-5.411-3.305-5.411-3.305",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.635 38.276s-.235-2.907.34-4.65c.578-1.74 5.694-11.766 5.694-11.766s1.635.32.455 3.418c-1.179 3.1-4.19 11.725-1.078 16.303 3.113 4.58-5.411-3.305-5.411-3.305z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.003 73.194-3.04-9.233s1.107-7.144-.431-10.068c-1.206-2.29-7.967-9.643-15.28-11.156-7.313-1.514-12.561-3.433-15.82-5.962-3.258-2.53-5.546-8.608-8.326-7.767C.038 29.33 7.383 40.08 7.383 40.08s7.324 6.623 8.533 12.456c1.209 5.835 13.982 26.039 13.982 26.039l14.105-5.38z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.003 73.194-3.04-9.233s1.107-7.144-.431-10.068c-1.206-2.29-7.967-9.643-15.28-11.156-7.313-1.514-12.561-3.433-15.82-5.962-3.258-2.53-5.546-8.608-8.326-7.767C.038 29.33 7.383 40.08 7.383 40.08s7.324 6.623 8.533 12.456c1.209 5.835 13.982 26.039 13.982 26.039l14.105-5.38z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.433 36.775s3.528 2.314 4.642 2.49",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.433 36.775s3.528 2.314 4.642 2.49",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.378 29.484s-1.007 4.297-1.264 6.667",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.378 29.484s-1.007 4.297-1.264 6.667",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.426 104.774c-.747 0-1.497-.071-2.242-.214a11.872 11.872 0 0 1-8.15-5.899L22.66 76.344l20.785-11.462 5.481 9.888 26.625-21.726L90.59 71.376l-37.645 30.72a11.899 11.899 0 0 1-7.52 2.678",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.552 53.044s9.1-1.599 10.942-1.599c1.842 0 1.052 17.33 16.058 15.229 15.006-2.1 7.095 22.855 1.842 25.731-6.251 3.423-28.43-3.676-29.483.525-1.054 4.201.64-39.886.64-39.886",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47 43.052s-3.403-1.386-3.872-3.996c-.47-2.61.115-4.27-.964-6.026-1.079-1.754-2.695-2.68-2.916-2.606-.22.074-.928.88-.437 2.1.491 1.218.302 5.026-.087 6.783-.186.842-9.27 12.988-8.88 15.339 1.432 8.636 16.693-10.544 17.156-11.594",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47 43.052s-3.403-1.386-3.872-3.996c-.47-2.61.115-4.27-.964-6.026-1.079-1.754-2.695-2.68-2.916-2.606-.22.074-.928.88-.437 2.1.491 1.218.302 5.026-.087 6.783-.186.842-9.27 12.988-8.88 15.339 1.432 8.636 16.693-10.544 17.156-11.594z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.005 30.98s-4.627-.6-5.83-.467c-1.204.132-8.45 1.037-8.45 1.037s-1.111 1.269.68 2.042c1.792.775 7.829.282 8.56.27.73-.01 6.421 2.66 6.276 2.294-.145-.366-1.236-5.176-1.236-5.176",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.005 30.98s-4.627-.6-5.83-.467c-1.204.132-8.45 1.037-8.45 1.037s-1.111 1.269.68 2.042c1.792.775 7.829.282 8.56.27.73-.01 6.421 2.66 6.276 2.294-.145-.366-1.236-5.176-1.236-5.176z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.335 28.93s-8.119-1.013-8.89-1.067c-.773-.054-2.928-.961-3.039-.706-.11.255-.31 2.221 1.16 2.927 1.472.705 9.28 2.378 10.985 1.738 1.704-.64-.216-2.892-.216-2.892",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.335 28.93s-8.119-1.013-8.89-1.067c-.773-.054-2.928-.961-3.039-.706-.11.255-.31 2.221 1.16 2.927 1.472.705 9.28 2.378 10.985 1.738 1.704-.64-.216-2.892-.216-2.892z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.366 38.276s.234-2.907-.343-4.65c-.576-1.74-5.691-11.766-5.691-11.766s-1.636.32-.456 3.418c1.179 3.1 4.19 11.725 1.078 16.303-3.113 4.58 5.412-3.305 5.412-3.305",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.366 38.276s.234-2.907-.343-4.65c-.576-1.74-5.691-11.766-5.691-11.766s-1.636.32-.456 3.418c1.179 3.1 4.19 11.725 1.078 16.303-3.113 4.58 5.412-3.305 5.412-3.305z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.997 73.194 3.04-9.233s-1.107-7.144.431-10.068c1.206-2.29 7.967-9.643 15.28-11.156 7.313-1.514 12.561-3.433 15.82-5.962 3.258-2.53 5.546-8.608 8.326-7.767 1.068.322-6.277 11.072-6.277 11.072s-7.324 6.623-8.533 12.456c-1.209 5.835-13.982 26.039-13.982 26.039l-14.105-5.38z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.997 73.194 3.04-9.233s-1.107-7.144.431-10.068c1.206-2.29 7.967-9.643 15.28-11.156 7.313-1.514 12.561-3.433 15.82-5.962 3.258-2.53 5.546-8.608 8.326-7.767 1.068.322-6.277 11.072-6.277 11.072s-7.324 6.623-8.533 12.456c-1.209 5.835-13.982 26.039-13.982 26.039l-14.105-5.38z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.567 36.775s-3.528 2.314-4.642 2.49",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.567 36.775s-3.528 2.314-4.642 2.49",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.622 29.484s1.007 4.297 1.263 6.667",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.622 29.484s1.007 4.297 1.263 6.667",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.574 104.774c.747 0 1.497-.071 2.242-.214a11.872 11.872 0 0 0 8.15-5.899l12.373-22.317-20.785-11.462-5.481 9.888-26.625-21.726-15.039 18.332 37.645 30.72a11.899 11.899 0 0 0 7.52 2.678",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.448 53.044s-9.1-1.599-10.942-1.599c-1.842 0-1.052 17.33-16.058 15.229-15.006-2.1-7.095 22.855-1.842 25.731 6.251 3.423 28.43-3.676 29.483.525 1.054 4.201-.64-39.886-.64-39.886",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08 30.379c-.9 1.556-3.244 1.888-5.234.743-1.99-1.146-2.873-3.336-1.972-4.893.9-1.556 3.244-1.888 5.234-.743 1.99 1.146 2.872 3.336 1.972 4.893",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08 30.379c-.9 1.556-3.244 1.888-5.234.743-1.99-1.146-2.873-3.336-1.972-4.893.9-1.556 3.244-1.888 5.234-.743 1.99 1.146 2.872 3.336 1.972 4.893z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.926 24.744c1.137 1.394.612 3.697-1.17 5.142-1.784 1.446-4.15 1.486-5.286.092-1.137-1.394-.613-3.697 1.17-5.142 1.783-1.445 4.15-1.486 5.286-.092",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.926 24.744c1.137 1.394.612 3.697-1.17 5.142-1.784 1.446-4.15 1.486-5.286.092-1.137-1.394-.613-3.697 1.17-5.142 1.783-1.445 4.15-1.486 5.286-.092z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.338 24.025c-5.639-.751-10.162-8.971-10.162-8.971s-1.337 9.02-6.619 11.128c-.473.188-.189 9.43 3.593 12.637 1.223 1.037 3.216 2.83 7.375 2.075a.942.942 0 0 0 .355-.14c3.047-.655 4.275-2.47 5.08-3.599 2.88-4.032.882-13.063.378-13.13",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.338 24.025c-5.639-.751-10.162-8.971-10.162-8.971s-1.337 9.02-6.619 11.128c-.473.188-.189 9.43 3.593 12.637 1.223 1.037 3.216 2.83 7.375 2.075a.942.942 0 0 0 .355-.14c3.047-.655 4.275-2.47 5.08-3.599 2.88-4.032.882-13.063.378-13.13z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.872 31.338c-1.054.308-2.845.464-4.026-.216-1.99-1.146-2.873-3.337-1.972-4.892.9-1.557 4.234-1.809 5.873.078",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.872 31.338c-1.054.308-2.845.464-4.026-.216-1.99-1.146-2.873-3.337-1.972-4.892.9-1.557 4.234-1.809 5.873.078",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11 24.685c1.96-1.588 4.482-1.728 5.636-.312s.502 3.85-1.457 5.438c-1.102.894-2.383 1.329-3.498 1.286",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11 24.685c1.96-1.588 4.482-1.728 5.636-.312s.502 3.85-1.457 5.438c-1.102.894-2.383 1.329-3.498 1.286",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.338 24.025c-5.639-.751-10.162-8.971-10.162-8.971s-1.337 9.02-6.619 11.128c-.473.188-.189 9.43 3.593 12.637 1.223 1.037 3.216 2.83 7.375 2.075a.942.942 0 0 0 .355-.14c3.047-.655 4.275-2.47 5.08-3.599 2.88-4.032.882-13.063.378-13.13",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.338 24.025c-5.639-.751-10.162-8.971-10.162-8.971s-1.337 9.02-6.619 11.128c-.473.188-.189 9.43 3.593 12.637 1.223 1.037 3.216 2.83 7.375 2.075a.942.942 0 0 0 .355-.14c3.047-.655 4.275-2.47 5.08-3.599 2.88-4.032.882-13.063.378-13.13z",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.815 26.937-.126 4.778s.379.377 1.134.377",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.815 26.937-.126 4.778s.379.377 1.134.377",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.294 34.859s.125 1.634 5.042 1.257",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.294 34.859s.125 1.634 5.042 1.257",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.245 26.476s1.071-.866 1.986-.267",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.245 26.476s1.071-.866 1.986-.267",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.242 26.41s1.608-.833 2.68 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.242 26.41s1.608-.833 2.68 0",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.242 29.592s1.608.833 2.68 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.242 29.592s1.608.833 2.68 0",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.871 29.592s1.608.833 2.68 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.871 29.592s1.608.833 2.68 0",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m93.732 131.616 18.56-32.91H80.439l-.333 5.509-64.92 16.672c-8.183 2.101-13.76 9.65-13.348 18.07.412 8.42 6.7 15.391 15.05 16.687l123.465 19.167 5.48-35.107-52.1-8.088z",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.439 98.706-.333 5.508-64.919 16.673c-8.185 2.102-13.762 9.65-13.35 18.07.413 8.42 6.7 15.39 15.051 16.688l123.465 19.166",
    stroke: "#000",
    strokeWidth: 1.892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.892,
    d: "m38.055 124.7 107.777 15.004"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCarsAdded);
export default __webpack_public_path__ + "static/media/no-cars-added.05df69f093d39257f4bf6286a0289fcb.svg";
export { ForwardRef as ReactComponent };